let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fW3mS")).then(() => parcelRequire('iyJtd'));